import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useDispatch } from 'react-redux';
import { Divider, Typography, Body, Stack } from '@optimus-web/core';
import { intersperse } from '@mews/fp';
import { SalesforceArticleInfo } from '@mews-commander/data-access';
import { Empty, Loader, OptimusPlainLink } from '@mews-commander/ui';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { navigateToArticle } from '../actions';

interface Props {
    articles: Array<SalesforceArticleInfo>;
    isLoading: boolean;
}

const renderArticles = (articles: Array<SalesforceArticleInfo>, dispatch: CommanderThunkDispatch) =>
    pipe(
        articles,
        array.map(({ id, title, summary, url }: SalesforceArticleInfo) => (
            <Stack key={id} vertical>
                <OptimusPlainLink
                    href={url}
                    onClick={() => dispatch(navigateToArticle(url, id, 'KnowledgeBaseArticle'))}
                    data-test-knowledge-article-id={id}
                    inherit
                >
                    <Typography textStyle="bodyMediumStrong" as="div">
                        {title}
                    </Typography>
                </OptimusPlainLink>
                <Body size="small">{summary}</Body>
            </Stack>
        )),
        intersperse((index: number) => <Divider key={index} />)
    );

export const KnowledgeArticleList = ({ articles, isLoading }: Props) => {
    const dispatch = useDispatch();

    if (isLoading) {
        return <Loader />;
    }

    if (array.isEmpty(articles)) {
        return <Empty />;
    }

    return (
        <Stack spacing="200" vertical>
            {renderArticles(articles, dispatch)}
        </Stack>
    );
};
